import { Record } from "immutable";

export const menuItemFromJSON = (json: Partial<IMenuItemData>): MenuItemRecord => {
  const recordData: IMenuItemRecord = { ...(json as any) };

  return new MenuItemRecord(recordData);
};

export interface IMenuItemData {
  id: string;
  hideInPresentMode?: boolean;
}

export interface IMenuItemRecord {
  id: string;
  hideInPresentMode?: boolean;
}

export const defaultMenuItemProps: IMenuItemRecord = {
  id: "",
  hideInPresentMode: false,
};

export class MenuItemRecord extends Record(defaultMenuItemProps) implements IMenuItemRecord {}
